
  import { Component, Vue,Prop,Inject } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    private index = -1
    @Prop({default:''}) modekey!:''
    @Inject() information:any
    get value(){
      return this.information
    }
    
    @Inject() editinfo:any
    get editmsg(){
      return this.information.find(v=>{
        return v.key == this.modekey
      })
    }

    private getAllShop(){
      let list = []
      this.editmsg.list.map(v=>{
        v.shopList.map(x=>{
          if(!list.find(z=>z.Id==x.Id)){
            list.push(x)
          }
        })
      })
      return list
    }
  }
